"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedEntityType = exports.JournalEntryType = void 0;
var JournalEntryType;
(function (JournalEntryType) {
    JournalEntryType["Income"] = "income";
    JournalEntryType["Bill"] = "bill";
})(JournalEntryType = exports.JournalEntryType || (exports.JournalEntryType = {}));
var LinkedEntityType;
(function (LinkedEntityType) {
    LinkedEntityType["Bill"] = "bill";
    LinkedEntityType["Invoice"] = "invoice";
    LinkedEntityType["Payment"] = "payment";
    LinkedEntityType["FinancialRecord"] = "financialRecord";
})(LinkedEntityType = exports.LinkedEntityType || (exports.LinkedEntityType = {}));
